// Excelleta Tech Website Data

// Company Logo
export const

    companyLogo = "https://customer-assets.emergentagent.com/job_pricemetal/artifacts/5fi4rhzg_Final%20logo02.png";

// Professional Images for visual sections
export const siteImages = {
    hero: "https://images.pexels.com/photos/1145434/pexels-photo-1145434.jpeg?auto=compress&cs=tinysrgb&w=1920",
    manufacturing: "https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg?auto=compress&cs=tinysrgb&w=800",
    cncMachine: "https://images.pexels.com/photos/50691/drill-milling-milling-machine-drilling-50691.jpeg?auto=compress&cs=tinysrgb&w=800",
    analytics: "https://images.pexels.com/photos/577195/pexels-photo-577195.jpeg?auto=compress&cs=tinysrgb&w=800",
    teamwork: "https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=800",
    collaboration: "https://images.pexels.com/photos/3862627/pexels-photo-3862627.jpeg?auto=compress&cs=tinysrgb&w=800",
    autoParts: "https://images.pexels.com/photos/7568433/pexels-photo-7568433.jpeg?auto=compress&cs=tinysrgb&w=800",
    factory: "https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&w=800",
    platform: "https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&w=800",
    dashboard: "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=800",
    about: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800",
    whyUs: "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=800",
    digital: "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=800",
    // Problem section images
    excelChaos: "https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=600",
    frustrated: "https://images.pexels.com/photos/3760790/pexels-photo-3760790.jpeg?auto=compress&cs=tinysrgb&w=600",
    solution: "https://images.pexels.com/photos/7688460/pexels-photo-7688460.jpeg?auto=compress&cs=tinysrgb&w=600",
    automation: "https://images.pexels.com/photos/8386434/pexels-photo-8386434.jpeg?auto=compress&cs=tinysrgb&w=600"
};

// Calendly Link for Demo Booking
export const calendlyLink = "https://calendly.com/excelleta-info/30min";

const newLocal = [
    // { name: "Rockman Industries", logo: "https://www.excelleta.tech/assets/images/rockman.jpg" },
    // { name: "Kaitaing", logo: "https://www.excelleta.tech/assets/images/kataing.jpg" },
    // { name: "Bony Polymers", logo: "https://www.excelleta.tech/assets/images/bony.jpg" },
    // { name: "Mega Autocomp", logo: "https://www.excelleta.tech/assets/images/mega1.jpg" },
    // { name: "National Engineering", logo: "https://www.excelleta.tech/assets/images/national.jpg" },
    // { name: "MMT", logo: "https://www.excelleta.tech/assets/images/mmt.jpg" },
    // { name: "Abhijay Industries", logo: "https://www.excelleta.tech/assets/images/abhijay.jpg" },
    // { name: "Mega Industries", logo: "https://www.excelleta.tech/assets/images/mega.jpg" },
    // { name: "POL", logo: "https://www.excelleta.tech/assets/images/pol.jpg" },
    // { name: "Velangi", logo: "https://www.excelleta.tech/assets/images/velangi.jpg" },
    // { name: "Dhanajay", logo: "https://www.excelleta.tech/assets/images/dhanajay.jpg" },
    // { name: "Brand Partner", logo: "https://www.excelleta.tech/assets/images/brand-2.jpg" }
    { name: "Rockman Industries", logo: "images/rockman.jpg" },
    { name: "Kaitaing", logo: "images/kataing.jpg" },
    { name: "Bony Polymers", logo: "images/bony.jpg" },
    { name: "Mega Autocomp", logo: "images/mega1.jpg" },
    { name: "MMT Autocomp", logo: "images/mmt.jpg" },
    { name: "Abhijay Auto Parts", logo: "images/abhijay.jpg" },
    { name: "Mega Industries", logo: "images/mega.jpg" },
    { name: "POLYRA PLASTICS", logo: "images/pol.jpg" },
    { name: "Dhanajay", logo: "images/dhanajay.jpg" },
    { name: "Brand Partner", logo: "images/brand-2.png" }
];
// Client Logos from existing website
export const clientLogos = newLocal;

export const heroData = {
    headline: "Smart Quotes. Faster Wins.",
    subtext: "Automate your RFQ-to-Quote workflow. Win more deals.",
    primaryCta: "Book a Demo",
    trustBadges: [
        "Trusted by 50+ manufacturers",
        "50-70% faster quotations",
        "CII DigiTech recognized"
    ]
};

export const benefitBlocks = [{
        icon: "Zap",
        title: "Faster RFQ Turnaround",
        description: "Reduce quotation time from days to hours with automated pricing and streamlined approvals."
    },
    {
        icon: "Database",
        title: "Centralized Data",
        description: "One platform for all RFQs, BOMs, quotes, and customer data—no more scattered spreadsheets."
    },
    {
        icon: "Target",
        title: "Auto Quote Generation",
        description: "Intelligent quote engine with norms libraries generates accurate quotes automatically."
    },
    {
        icon: "Eye",
        title: "Real-Time Visibility",
        description: "Live dashboards show RFQ status, SLA timers, profitability, and team performance instantly."
    },
    {
        icon: "Shield",
        title: "Complete Auditability",
        description: "Every change is tracked. Version control, approval history, and audit trails built-in."
    }
];

export const howItWorks = [{
        step: 1,
        title: "Capture & Assign",
        description: "RFQs are logged centrally, auto-categorized, and assigned to the right team members with SLA timers."
    },
    {
        step: 2,
        title: "Evaluate & Cost",
        description: "Technical feasibility, BOM creation, and automated costing happen in parallel with norms-based calculations."
    },
    {
        step: 3,
        title: "Review & Approve",
        description: "Multi-level approval workflows route quotes to the right stakeholders with complete visibility."
    },
    {
        step: 4,
        title: "Quote & Win",
        description: "Generate professional quotations, track customer responses, and analyze win/loss patterns."
    }
];

export const problemData = {
    heading: "Still Stuck in Spreadsheet Chaos?",
    subheading: "Manual processes are costing you deals",
    painPoints: [
        { icon: "FileSpreadsheet", text: "Multiple file versions create confusion and costly errors", image: "excelChaos" },
        { icon: "Clock", text: "Manual quote generation takes days instead of hours", image: "frustrated" },
        { icon: "AlertTriangle", text: "No audit trail—who changed what and when?", image: "solution" },
        { icon: "Eye", text: "Management lacks real-time visibility into RFQ pipeline", image: "automation" }
    ]
};

export const platformModules = [{
        id: "rfq",
        title: "RFQ Capture & Tracking",
        icon: "Inbox",
        overview: "Centralized workspace for all customer RFQs with live status, SLA timers, and automated escalations.",
        features: [
            "Centralized RFQ inbox with auto-categorization",
            "Real-time status tracking and SLA monitoring",
            "Automated alerts and escalation triggers",
            "Document standardization and attachment management",
            "Customer-specific requirement handling",
            "Integration with email for seamless RFQ capture"
        ],
        benefits: [
            "Never miss an RFQ deadline again",
            "50-70% faster RFQ processing",
            "Complete visibility for management reviews",
            "Reduced coordination overhead across teams"
        ]
    },
    {
        id: "bom",
        title: "BOM & Technical Evaluation",
        icon: "Layers",
        overview: "Streamlined Bill of Materials creation with multi-level support, version control, and CAD/PLM integration.",
        features: [
            "Streamlined BOM creation from drawings",
            "Multi-level BOM support (parent-child hierarchies)",
            "BOM version control and comparison",
            "Component tracking and reusability",
            "CAD/PLM integration for drawing data",
            "ECN (Engineering Change Notice) handling"
        ],
        benefits: [
            "Zero version conflicts with BOM compare",
            "Traceable, error-free outputs",
            "Faster technical evaluation cycles",
            "Historical BOM data for reuse"
        ]
    },
    {
        id: "quoting",
        title: "Smart Quote Engine",
        icon: "Calculator",
        overview: "Automated quote generation using norms libraries, MHR rates, and intelligent pricing methods.",
        features: [
            "Multiple quote methods (Internal, Customer, Tooling)",
            "Auto-quote generation from BOM/TE sheet",
            "Machine Hour Rate (MHR) libraries",
            "Surface treatment and process rate cards",
            "Norms manager for labor, tooling, packing",
            "Instant profitability view (P&L, EBITDA, IRR)"
        ],
        benefits: [
            "Quote prep time cut by 50-70%",
            "Quote accuracy improved to 100%",
            "Margin optimization with profitability insights",
            "Standardized pricing across all plants"
        ]
    },
    {
        id: "workflow",
        title: "Workflow & Approvals",
        icon: "GitBranch",
        overview: "Configurable approval workflows with role-based access, audit trails, and compliance tracking.",
        features: [
            "Multi-level approval workflows",
            "Role-based access control (RBAC)",
            "Quote versioning with side-by-side comparison",
            "Complete audit trail and history",
            "Automated notifications at each stage",
            "Compliance-ready documentation"
        ],
        benefits: [
            "Faster approvals with clear accountability",
            "No more approval bottlenecks",
            "Complete traceability for audits",
            "Reduced rework from version conflicts"
        ]
    },
    {
        id: "analytics",
        title: "Dashboards & Analytics",
        icon: "BarChart3",
        overview: "Real-time dashboards and reports for RFQ funnel, conversion rates, and business performance.",
        features: [
            "RFQ funnel and conversion ratio tracking",
            "RFQ aging and delay reports",
            "Quote trend analysis across customers/parts",
            "Supplier performance scorecards",
            "KAM (Key Account Manager) metrics",
            "Custom report builder with export"
        ],
        benefits: [
            "Management reviews in minutes, not hours",
            "Data-driven decision making",
            "Early identification of bottlenecks",
            "Win/loss pattern analysis"
        ]
    },
    {
        id: "masters",
        title: "Master Data Management",
        icon: "Database",
        overview: "Centralized management of customers, parts, suppliers, and rate libraries.",
        features: [
            "Customer and contact management",
            "Part master with specifications",
            "Supplier and vendor rate library",
            "RM (Raw Material) amendment tracking",
            "Customer-specific norms and preferences",
            "Historical data for intelligent reuse"
        ],
        benefits: [
            "Single source of truth for all master data",
            "RM price change impact alerts",
            "Faster quoting with historical reference",
            "Optimized supplier management"
        ]
    }
];

export const comparisonData = {
    dimensions: [
        { category: "Data Centralization", excel: "Scattered files across systems", excelleta: "Single unified platform" },
        { category: "Version Control", excel: "Manual, error-prone", excelleta: "Automatic with comparison" },
        { category: "Approval Tracking", excel: "Via email, hard to trace", excelleta: "Built-in workflows with audit" },
        { category: "Audit Trail", excel: "None or limited", excelleta: "Complete history of changes" },
        { category: "Team Collaboration", excel: "File sharing chaos", excelleta: "Real-time, role-based access" },
        { category: "Turnaround Time", excel: "5-7 days typical", excelleta: "1-2 days with automation" },
        { category: "Error Rate", excel: "15-20% typical", excelleta: "0% with smart validation" },
        { category: "Management Visibility", excel: "Manual reports, delayed", excelleta: "Real-time dashboards" },
        { category: "Scalability", excel: "Degrades with volume", excelleta: "Enterprise-grade, unlimited" },
        { category: "Security", excel: "Basic file protection", excelleta: "Enterprise encryption & RBAC" },
        { category: "ERP Integration", excel: "Manual re-entry", excelleta: "Seamless connectivity" },
        { category: "Quote Accuracy", excel: "Formula errors common", excelleta: "Norms-based, validated" }
    ]
};

export const industriesData = [{
        icon: "Car",
        title: "Auto-Component Manufacturers",
        description: "Tier 1, 2, 3 suppliers managing high-volume RFQs from OEMs",
        challenges: [
            "High RFQ volume with tight deadlines",
            "Complex BOMs with frequent revisions",
            "OEM-specific quote formats required",
            "Multi-plant coordination challenges"
        ]
    },
    {
        icon: "Factory",
        title: "Fabrication, Sheet Metal & Plastics",
        description: "Custom fabrication, plastic molding, rubber parts, and casting manufacturers",
        challenges: [
            "Process-specific pricing complexity",
            "Material yield and scrap calculations",
            "Tooling cost amortization",
            "Quick-turn quotation demands"
        ]
    },
    {
        icon: "Wrench",
        title: "Tool & Die Manufacturers",
        description: "Precision tooling with complex development cycles",
        challenges: [
            "Tooling lifecycle tracking",
            "Trial and development allocation",
            "Design revision management",
            "Long project timelines"
        ]
    },
    {
        icon: "Building2",
        title: "Engineering & EPC",
        description: "Project-based manufacturing with engineering complexity",
        challenges: [
            "Multi-discipline coordination",
            "Change order management",
            "Subcontractor cost consolidation",
            "Project profitability tracking"
        ]
    }
];

export const implementationSteps = [{
        phase: "Discovery",
        duration: "Week 1",
        description: "Understand your current RFQ process, pain points, and requirements. Map existing workflows and data sources."
    },
    {
        phase: "Configuration",
        duration: "Week 2-3",
        description: "Set up the platform with your costing templates, approval workflows, and master data structures."
    },
    {
        phase: "Data Migration",
        duration: "Week 3-4",
        description: "Import existing customer data, part masters, rate libraries, and historical references."
    },
    {
        phase: "UAT & Training",
        duration: "Week 4-5",
        description: "User acceptance testing with your team. Role-based training for costing engineers, sales, and management."
    },
    {
        phase: "Go-Live",
        duration: "Week 5-6",
        description: "Controlled go-live with hypercare support. Parallel running option available for risk mitigation."
    },
    {
        phase: "Optimization",
        duration: "Ongoing",
        description: "Continuous improvement based on usage patterns. Regular check-ins and feature enhancements."
    }
];

export const testimonials = [{
        quote: "We went from 5-day quotation cycles to under 2 days. The BOM version control alone saved us countless hours of rework.",
        author: "Operations Head",
        role: "Tier-1 Auto-Component Manufacturer",
        company: "Leading Automotive Supplier"
    },
    {
        quote: "Finally, our management has real-time visibility into the RFQ pipeline. Weekly reviews now take minutes instead of half a day.",
        author: "VP Sales",
        role: "Sheet Metal Fabrication Company",
        company: "Mid-size Manufacturing Enterprise"
    },
    {
        quote: "The audit trail and approval workflows gave us the control we needed. No more confusion about who approved what.",
        author: "Costing Manager",
        role: "Multi-plant Manufacturing Setup",
        company: "Engineering Products Company"
    }
];

export const companyInfo = {
    name: "Excelleta Tech Pvt. Ltd.",
    tagline: "Smarter Workflows. Better Growth.",
    mission: "To digitize and streamline RFQ-to-Costing operations for manufacturing companies, replacing scattered spreadsheets with intelligent, unified platforms.",
    vision: "To be the trusted partner for manufacturing companies seeking operational excellence through purpose-built technology solutions.",
    values: [
        { name: "Passion", description: "Deeply committed to solving manufacturing challenges" },
        { name: "Perfection", description: "Attention to detail in every solution we deliver" },
        { name: "Pride", description: "Taking ownership of our work and its outcomes" },
        { name: "Promptness", description: "Delivering results swiftly without compromising quality" }
    ],
    address: "No 706 Block-E 7th floor, Dwarka Sector 19B, (Opposite Dwarka Golf Course) New Delhi 110075",
    email: "info@excelleta.tech",
    salesEmail: "skshrivastava@excelleta.tech",
    phone: "+91 7290076170",
    whatsapp: "+917290076170"
};

export const navLinks = [
    { label: "Platform", href: "#platform" },
    { label: "Solutions", href: "#solutions" },
    { label: "Why Excelleta", href: "#why-excelleta" },
    { label: "About", href: "#about" }
];

export const stats = [
    { value: 100, suffix: "<70%", label: "Faster Quotation" },
    { value: 100, suffix: "100%", label: "Quote Accuracy" },
    { value: 100, suffix: "100%", label: "Real-time Dashboard" },
    { value: 100, suffix: "<50%", label: "Less Rework" }
];